import { render, staticRenderFns } from "./distributorPlatformConfigModal.vue?vue&type=template&id=3f06b1e2"
import script from "./distributorPlatformConfigModal.vue?vue&type=script&lang=js"
export * from "./distributorPlatformConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports